import { ApiTypes } from "types"
import SubscriptionPlan from "types/enums/SubscriptionPlan"

export const isRestrictedSubscriptionPlan = (userProfile?: ApiTypes.Model.UserProfile | null): boolean => {
  const subscriptionPlan = userProfile?.contractor?.subscription_plan

  return subscriptionPlan === SubscriptionPlan.BASIC_OCT_2025
}
